import React from 'react';
import { X as CloseIcon, Timer, Eye, BarChart3, Clock } from 'lucide-react';

const SessionDetailsModal = ({
  sessionModalOpen,
  selectedSession,
  setSessionModalOpen
}) => {
  if (!sessionModalOpen || !selectedSession) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-2 sm:p-4">
      <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        {/* Modal Header */}
        <div className="flex items-center justify-between p-4 sm:p-6 border-b">
          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900">Session Details</h3>
            <p className="text-xs sm:text-sm text-gray-500 mt-1">
              {new Date(selectedSession.startTime).toLocaleDateString()} at {new Date(selectedSession.startTime).toLocaleTimeString()}
            </p>
          </div>
          <button
            onClick={() => setSessionModalOpen(false)}
            className="p-1.5 sm:p-2 text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <CloseIcon className="w-5 h-5 sm:w-6 sm:h-6" />
          </button>
        </div>
        {/* Modal Content */}
        <div className="flex-1 overflow-y-auto p-4 sm:p-6">
          {/* Session Summary Cards */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
            <div className="bg-blue-50 rounded-lg sm:rounded-xl p-3 sm:p-4 text-center">
              <Timer className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 mx-auto mb-1.5 sm:mb-2" />
              <div className="text-xl sm:text-2xl font-bold text-blue-900">
                {Math.round(selectedSession.totalDuration / 60000 * 100) / 100}
              </div>
              <div className="text-xs sm:text-sm text-blue-700">Minutes Total</div>
            </div>
            <div className="bg-green-50 rounded-lg sm:rounded-xl p-3 sm:p-4 text-center">
              <Eye className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 mx-auto mb-1.5 sm:mb-2" />
              <div className="text-xl sm:text-2xl font-bold text-green-900">
                {selectedSession.slidesViewed.length}
              </div>
              <div className="text-xs sm:text-sm text-green-700">Slides Viewed</div>
            </div>
            <div className="bg-purple-50 rounded-lg sm:rounded-xl p-3 sm:p-4 text-center">
              <BarChart3 className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600 mx-auto mb-1.5 sm:mb-2" />
              <div className="text-xl sm:text-2xl font-bold text-purple-900">
                {selectedSession.completionRate}%
              </div>
              <div className="text-xs sm:text-sm text-purple-700">Completion</div>
            </div>
            <div className="bg-orange-50 rounded-lg sm:rounded-xl p-3 sm:p-4 text-center">
              <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-orange-600 mx-auto mb-1.5 sm:mb-2" />
              <div className="text-xl sm:text-2xl font-bold text-orange-900">
                {selectedSession.avgTimePerSlide}s
              </div>
              <div className="text-xs sm:text-sm text-orange-700">Avg Per Slide</div>
            </div>
          </div>
          {/* ...You can add the rest of the session details here as in your original modal... */}
        </div>
        {/* Modal Footer */}
        <div className="p-4 sm:p-6 border-t bg-gray-50 rounded-b-xl sm:rounded-b-2xl">
          <div className="flex items-center justify-between">
            <div className="text-xs sm:text-sm text-gray-600">
              Session ID: {selectedSession.sessionId}
            </div>
            <button
              onClick={() => setSessionModalOpen(false)}
              className="px-3 sm:px-4 py-1.5 sm:py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg transition-colors text-xs sm:text-sm"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SessionDetailsModal; 